export const MAIN_SIDEBAR_MENU_WIDTH = 64;
export const MAIN_SIDEBAR_MENU_EXPANDED_WIDTH = 272;
